module.exports = __webpack_public_path__ + "static/img/S380-PF_A.b944669.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/S380-PF_A.jpg
// module id = jn0l
// module chunks = 0